module.exports = __webpack_public_path__ + "media/app/assets/races/nightborne_male-25ea052daacd92e14c7af1a777d5cc62.png";